module.exports = __webpack_public_path__ + "img/22.c4b5c2ba.jpg";